var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotLoggedInWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1425 13.936C13.0585 13.924 12.9505 13.924 12.8545 13.936C10.7425 13.864 9.0625 12.136 9.0625 10.012C9.0625 7.83996 10.8145 6.07596 12.9985 6.07596C15.1705 6.07596 16.9345 7.83996 16.9345 10.012C16.9225 12.136 15.2545 13.864 13.1425 13.936Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0901 21.8557C18.9541 23.8117 16.1221 24.9997 13.0021 24.9997C9.88206 24.9997 7.05006 23.8117 4.91406 21.8557C5.03406 20.7277 5.75406 19.6237 7.03806 18.7597C10.3261 16.5757 15.7021 16.5757 18.9661 18.7597C20.2501 19.6237 20.9701 20.7277 21.0901 21.8557Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotLoggedInWhite);
export default __webpack_public_path__ + "static/media/profileNotLoggedInWhite.b6f33210f4dfee99757f5d15da42dbe2.svg";
export { ForwardRef as ReactComponent };